<template>
  <div id="app" v-cloak>
      <transition :name="transitionName">
        <keep-alive :include="data">
            <router-view></router-view>
        </keep-alive>
      </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    // 数据存放在vuex里面
    // 是否只在该路由上添加路由缓存  ！！！注意 如果使用router里面的meta属性(v-if="$route.meta.keepAlive"),路由转场动画与路由缓存会冲突
    ...mapState({
      data: state => state.includeData.data
    })
  },
  methods: {
    // 设置缓存路由
    setKeep_alive (to) {
      if (to.name === 'demo') {
        this.$store.dispatch({
          type: 'setIncludeData',
          payload: 'demo'
        })
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 此时从from页面跳转到to页面
      this.setKeep_alive(to)
      // console.log(to)
      // console.log(from)
      const routeDeep = ['/', '/coreBusiness', '/services', '/whyUs', '/capabilities', '/hse', '/contactUs', '/projects','/demo']
      const toDepth = routeDeep.indexOf(to.path)
      const fromDepth = routeDeep.indexOf(from.path)
      if (!from.name) {
        this.transitionName = 'fold'
        return
      }
      // console.log(toDepth, fromDepth)
      // this.transitionName = toDepth > fromDepth ? 'fold-left' : 'fold-right'
      // console.log('this.transitionName:', this.transitionName)
    }
  },
  created () {

  }
}
</script>
>
<style lang="scss" scoped>
[v-cloak] {
  display:none !important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
  -webkit-user-select: none;
 -moz-user-select: none;
 -khtml-user-select: none;
  user-select: none;
}
.fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: .3s;
  }
  .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: .3s;
  }
.fold-right-enter-active {
    animation-name: fold-right-in;
    animation-duration: .3s;
  }
  .fold-right-leave-active {
    animation-name: fold-right-out;
    animation-duration: .3s;
  }
@keyframes fold-left-in {
    0% {
      transform: translate3d(100%, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fold-left-out {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(-100%, 0, 0);
    }
  }
  @keyframes fold-right-in {
    0% {
      transform: translate3d(-100%, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes fold-right-out {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(100%, 0, 0);
    }
  }
</style>
